import * as React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Divider from '@mui/material/Divider';

import {
  Box,
  Button,
} from '@mui/material';
import Horse from '../../pages/horse/Horse';

const HorsePopover = ({
  onClose,
  barnHorse,
  navigate,
  condensed,
}) => {
  const permissions = useSelector((state) => state.user.permissions);
  return (
    // <Dialog
    //   TransitionComponent={Transition}
    //   open={!!barnHorse}
    //   onClose={() => onClose()}
    //   PaperProps={{
    //     sx: {
    //       m: 0,
    //       mx: fullscreen
    //         ? 0
    //         : 2,
    //       width: '100%',
    //       maxWidth: 1200,
    //       backgroundColor: 'rgb(244, 244, 244)',
    //     },
    //   }}
    // >
    // </Dialog>
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
      }}
    >
      <Box />
      <DialogContent
        sx={{
          flex: 1,
          p: 0,
        }}
      >
        {
          barnHorse && (
            <Horse
              navigate={navigate}
              permissions={permissions}
              unreadCount={0}
              chatClient={null}
              pageWrapper={false}
              condensed={condensed}
              id={barnHorse.horse.id}
            />
          )
        }
      </DialogContent>
      <DialogActions sx={{ pt: 0 }}>
        <Box
          sx={{
            flex: 1,
            textAlign: 'right',
          }}
        >
          <Box sx={{ mb: 1 }}><Divider /></Box>
          <Button
            onClick={onClose}
            variant="contained"
          >
            Close
          </Button>
        </Box>
      </DialogActions>
    </Box>
  );
};

HorsePopover.propTypes = {
  onClose: PropTypes.func.isRequired,
  barnHorse: PropTypes.object,
  navigate: PropTypes.func.isRequired,
  condensed: PropTypes.bool,
};

HorsePopover.defaultProps = {
  barnHorse: null,
  condensed: false,
};

export default HorsePopover;
